<script lang="ts">
  import { TwistCheckbox } from '@twist/ui';
  import { accessibilityPreferences } from '$lib/stores/accessibility';
  import AccessibilityCheckboxControl from './Control.svelte';

  export let color = 'gray-0';

  type ChangeEvent = CustomEvent<{ checked: boolean }>;

  const handleReduceMotionChange = (e: ChangeEvent) => {
    accessibilityPreferences.setReduceMotion(e.detail.checked);
  };
</script>

<AccessibilityCheckboxControl>
  <TwistCheckbox
    label="Reduce motion"
    {color}
    checked={$accessibilityPreferences.reduceMotion || undefined}
    on:change={handleReduceMotionChange}
  />
</AccessibilityCheckboxControl>
